import React from "react";
import { Mail, Sparkles } from "lucide-react";
import Reveal from "../components/Reveal";
import { BOARD } from "../mock";

export default function Board() {
  return (
    <div>
      <section className="relative pt-16 sm:pt-24 pb-8 sm:pb-14 border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.28em] text-cyan-200/90 mb-6">Executive Board</p>
          <h1 className="font-serif-display text-[56px] md:text-[96px] font-bold leading-[0.98] text-white tracking-tight">
            Our <span className="hl-block-deep">board.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-slate-200 font-serif-body text-lg leading-relaxed">
            Meet the students leading BridgeColumbia’s mission to reduce polarization and foster open, responsible discourse on campus. Reach out to any board member directly by email.
          </p>
        </div>
      </section>

      <section className="py-8 sm:py-14">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {BOARD.map((m, i) => (
              <Reveal key={i} delay={(i % 3) * 60}>
                <article className="group rounded-2xl border border-white/15 bg-[#145074] p-6 hover:border-cyan-300/60 hover:bg-[#1a618d] transition-colors h-full flex flex-col">
                  <div className="flex items-start justify-between gap-4">
                    <div className="min-w-0 flex-1">
                      <p className="text-[11px] uppercase tracking-[0.22em] text-cyan-200">{m.role}</p>
                      <h3 className="mt-1 font-serif-display text-2xl text-white leading-tight">{m.name}</h3>
                      <p className="mt-1 text-sm text-slate-300">{m.school}</p>
                    </div>
                    {m.founder && (
                      <span
                        className="inline-flex items-center gap-1 rounded-full border border-cyan-300/40 bg-cyan-300/10 px-2.5 py-1 text-[10px] tracking-[0.16em] uppercase text-cyan-100 shrink-0"
                        title="Co-founder of BridgeColumbia"
                      >
                        <Sparkles className="w-3 h-3" /> Founder
                      </span>
                    )}
                  </div>
                  <a
                    href={`mailto:${m.email}`}
                    className="mt-6 inline-flex items-center gap-2 text-sm text-cyan-200 hover:text-cyan-100 link-underline break-all"
                  >
                    <Mail className="w-3.5 h-3.5 shrink-0" /> {m.email}
                  </a>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
